import React, { ReactElement, useContext } from "react";
import { ThemeContext, ThemeProvider } from "styled-components";

import Icon from "components/Icon";
import { appendComponentWithNoBr } from "utils/appendComponentWithNoBr";

import {
    Wrapper,
    Container,
    Heading,
    HeadingArrow,
    Description,
    Information,
} from "./OpenPosition.styled";
import OpenPositionProps from "./OpenPositionProps";

const OpenPosition = ({
    id,
    heading,
    description,
    lastApplicationDate,
    locations,
    url,
    theme,
    className,
    anchorName,
}: OpenPositionProps): ReactElement => {
    const themeContext = useContext(ThemeContext);
    const identifier = id ? id.toString() : "OpenPosition";

    return (
        <ThemeProvider theme={{ theme: theme || themeContext?.theme }}>
            <Wrapper className={className} id={anchorName}>
                <Container id={identifier} key={identifier}>
                    {heading && (
                        <Heading to={url} exact>
                            {appendComponentWithNoBr(
                                heading,
                                <HeadingArrow
                                    icon={"longArrowRight28"}
                                    aria-hidden="true"
                                />,
                            )}
                        </Heading>
                    )}
                    {description && <Description>{description}</Description>}
                    {description && (
                        <Information>
                            {locations && locations.length > 0 && (
                                <div>
                                    <Icon icon="location28" />
                                    {locations
                                        ?.map((location) => location.city)
                                        .join(", ")}
                                </div>
                            )}
                            {lastApplicationDate && (
                                <div>
                                    <Icon icon="deadline28" />
                                    {lastApplicationDate}
                                </div>
                            )}
                        </Information>
                    )}
                </Container>
            </Wrapper>
        </ThemeProvider>
    );
};

export default React.memo(OpenPosition);
